import classNames from 'classnames';

const StatusToggle = ({
  id,
  isActive,
  onToggle,
  activeText,
  inactiveText,
  activeBgColor,
  inactiveBgColor,
  activeTextColor,
  inactiveTextColor,
}) => {
  const bgColor = isActive ? activeBgColor : inactiveBgColor;
  const textColor = isActive ? activeTextColor : inactiveTextColor;

  return (
    <div
      className={`relative w-28 h-8 flex items-center rounded-full p-1 cursor-pointer transition-colors duration-300 ${bgColor} ${classNames}`}
      onClick={() => onToggle(id, !isActive)}
    >
      <div
        className={`absolute w-6 h-6 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
          isActive ? 'translate-x-20' : 'translate-x-0'
        }`}
      >
      </div>
      <div className={`flex items-center ${isActive ? 'justify-start' : 'justify-end'} w-full h-full ${textColor} z-10`}>
        <span className="font-semibold text-sm">{isActive ? activeText : inactiveText}</span>
      </div>
    </div>
  );
};

export default StatusToggle;
